import { categories } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function CategoriesSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-black text-foreground-950">
            内容分类
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-md mx-auto">
            五大板块全方位覆盖网红黑料资讯，总有你想看的
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-400 transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all duration-300 mb-4">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <span className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400 mt-1">{cat.nameEn}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}